export default function TopBar({ title, subtitle, actions }) {
  return (
    <header className="topbar">
      <div>
        <h1 data-testid="page-title">{title}</h1>
        {subtitle ? <p className="sub">{subtitle}</p> : null}
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </header>
  );
}
